export default "__VITE_ASSET__ClnJbPb2__"